module.exports = __webpack_public_path__ + "static/media/MissedCleans.b480ea56.PNG";